import RouteBase from '@/router/routes/RouteBase.js';

class RoutesLegend {
  subFolderPath = '/legend';
  isPublic = false;

  Home = new RouteBase({
    name: 'legend-home',
    path: '',
    componentFolderPath: `${this.subFolderPath}`,
    componentFileName: 'Home',
    isPublic: this.isPublic,
    meta: {
      icon: 'wave',
      appbarConfig: {
        isCollapsable: false,
        hasBackButton: true,
        title: 'İncelikte Marlboro Çağı',
      },
      breadcrumb: [
        {
          name: 'Ana Sayfa',
          link: '/secure/feed',
        },
        {
          name: 'İncelikte Marlboro Çağı',
        },
      ],
    },
  });
}

export default new RoutesLegend();
